import React, { useState } from 'react';
import { Button } from './ui/Button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/DropdownMenu';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from './ui/Sheet';
import { Phone, Menu, ChevronDown } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const serviceItems = ['Bistro Lights', 'Architectural Lights', 'Landscape Lights', 'Hardscape Lights', 'Sport Court Lights', 'Backyard Lights', 'Security Lights'];
  const serviceAreas = ['Chandler', 'Gilbert', 'Queen Creek', 'Mesa', 'Phoenix', 'Paradise Valley', 'Scottsdale', 'Fountain Hills', 'San Tan Valley', 'Tempe'];
  return <header className="sticky top-0 z-50 w-full bg-[var(--brand-black)] border-b border-white/10 backdrop-blur-sm" data-id="element-71">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="flex items-center justify-between h-20" data-id="element-73">
          {/* Logo */}
          <div className="flex items-center" data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/n43iiTDj7iFgnsp1aS7tbv/690afb49188ff968e0813148.png" alt="Love Outdoor Lighting" className="h-16 w-auto object-contain sm:h-20" data-id="element-75" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-76">
            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-77">
              Home
            </a>

            <DropdownMenu data-id="element-78">
              <DropdownMenuTrigger className="flex items-center gap-1 text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-79">
                Services <ChevronDown className="w-4 h-4" data-id="element-80" />
              </DropdownMenuTrigger>
              <DropdownMenuContent className="bg-white" data-id="element-81">
                {serviceItems.map(service => <DropdownMenuItem key={service} className="cursor-pointer" data-id="element-82">
                    {service}
                  </DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>

            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-83">
              Projects
            </a>

            <DropdownMenu data-id="element-84">
              <DropdownMenuTrigger className="flex items-center gap-1 text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-85">
                Service Areas <ChevronDown className="w-4 h-4" data-id="element-86" />
              </DropdownMenuTrigger>
              <DropdownMenuContent className="bg-white" data-id="element-87">
                {serviceAreas.map(area => <DropdownMenuItem key={area} className="cursor-pointer" data-id="element-88">
                    {area}
                  </DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>

            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-89">
              Blog
            </a>

            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-90">
              Contact
            </a>
          </nav>

          {/* Right Side: CTA + Phone */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-91">
            <a href="tel:480-270-2014" className="flex items-center gap-2 text-white hover:text-[var(--brand-gold)] transition-colors" data-id="element-92">
              <Phone className="w-5 h-5" data-id="element-93" />
              <span className="font-medium" data-id="element-94">480-270-2014</span>
            </a>
            <Button className="bg-[var(--brand-green)] hover:bg-green-700 text-white font-medium" data-id="element-95">
              Get a Free Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen} data-id="element-96">
            <SheetTrigger asChild className="lg:hidden" data-id="element-97">
              <Button variant="ghost" size="icon" className="text-white" data-id="element-98">
                <Menu className="w-6 h-6" data-id="element-99" />
                <span className="sr-only" data-id="element-100">Open menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[var(--brand-black)] text-white border-white/10" data-id="element-101">
              <SheetHeader data-id="element-102">
                <SheetTitle className="text-white text-left" data-id="element-103">Menu</SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col gap-6 mt-8" data-id="element-104">
                <a href="#" className="text-lg font-medium hover:text-[var(--brand-gold)] transition-colors" data-id="element-105">
                  Home
                </a>

                <div className="flex flex-col gap-3" data-id="element-106">
                  <span className="text-lg font-medium text-[var(--brand-gold)]" data-id="element-107">
                    Services
                  </span>
                  <div className="flex flex-col gap-2 pl-4" data-id="element-108">
                    {serviceItems.map(service => <a key={service} href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-109">
                        {service}
                      </a>)}
                  </div>
                </div>

                <a href="#" className="text-lg font-medium hover:text-[var(--brand-gold)] transition-colors" data-id="element-110">
                  Projects
                </a>

                <div className="flex flex-col gap-3" data-id="element-111">
                  <span className="text-lg font-medium text-[var(--brand-gold)]" data-id="element-112">
                    Service Areas
                  </span>
                  <div className="flex flex-col gap-2 pl-4" data-id="element-113">
                    {serviceAreas.map(area => <a key={area} href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-114">
                        {area}
                      </a>)}
                  </div>
                </div>

                <a href="#" className="text-lg font-medium hover:text-[var(--brand-gold)] transition-colors" data-id="element-115">
                  Blog
                </a>

                <a href="#" className="text-lg font-medium hover:text-[var(--brand-gold)] transition-colors" data-id="element-116">
                  Contact
                </a>

                <div className="flex flex-col gap-4 pt-6 border-t border-white/10" data-id="element-117">
                  <a href="tel:480-270-2014" className="flex items-center gap-2 text-white" data-id="element-118">
                    <Phone className="w-5 h-5 text-[var(--brand-gold)]" data-id="element-119" />
                    <span className="font-medium" data-id="element-120">480-270-2014</span>
                  </a>
                  <Button className="w-full bg-[var(--brand-green)] hover:bg-green-700 text-white font-medium" data-id="element-121">
                    Get a Free Quote
                  </Button>
                </div>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}